import React, { useEffect } from "react";
import styled from "styled-components";
import { GameStatus, CARDS_COORDS } from "./constants";
import Results from "./Board/Results/Results";
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import StyledContainer from "../../partials/StyledContainer";
import QuestionBox from "./QuestionBox/QuestionBox";
import GameStatusProvider, { useGameStatusContext } from "./providers/gameStatusProvider";
import ProgressProvider from "./providers/progressProvider";
import TimerProvider, { useTimerContext } from "./providers/timerProvider";
import QuestionProvider from "./providers/questionProvider";
import MissionElementsProvider, { useMissionElementsContext } from "./providers/missionElementsProvider";
import styles from "./MissionElements.module.scss";
import useRenderElementButton from "./hooks/useRenderElementButton";
import Button from '../../partials/Button'
import { ReactComponent as RoadStartSVG } from "./assets/road-start.svg";
import { ReactComponent as RoadSVG } from "./assets/road.svg";
import Modal, { ModalProvider } from "../../partials/Modal/v2/modal";
import { useFunc } from "ajv/dist/compile/util";

function MissionElements(props) {
  const pages = props.data.pages || {};
  const { options } = props.data || {};
  const { onComplete } = props
  
  const [gameStatus, setGameStatus] = useGameStatusContext();
  const [stateElements, dispatch] = useMissionElementsContext();
  //const secondsCount = useTimerContext();
  const renderElementButton = useRenderElementButton(options, );
  const [questionClosed, setQuestionClosed] = React.useState(true);
  const [showBox, setShowBox] = React.useState(false);

  const startGame = (e) => {
    if(gameStatus.round === "secondRound"){
      // setShowBox(false)
     
    }
    setGameStatus({
      ...gameStatus,
      status: GameStatus.STARTED,
    });
  };

  const closedQuestion = () => {
    console.log("closedQuestion" );   
  };

  useEffect(() => {    
    setShowBox(false)
  }, [gameStatus.status]);

  if (!stateElements) return null;

  return (
    <ModalProvider>
      <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}> 
        <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
        </div>

        <TopContainer>
          <Instructions>{options?.instructions || "Click cards to reveal a question."}</Instructions>
        </TopContainer>

        <Board>
          {stateElements.map((element, i) => (
            <div key={i}>
              {renderElementButton(element, gameStatus, CARDS_COORDS[i], i)}
            </div>
          ))}
          {gameStatus.status !== GameStatus.STARTED && <RoadStartSVG
            style={{
              position: "absolute",
            }}
          />}
          {gameStatus.status === GameStatus.STARTED && <RoadSVG
            style={{
              position: "absolute",
            }}
          />}
        </Board>

        {gameStatus.status !== GameStatus.FINISHED &&
        <Container>
          <h2></h2>
          {gameStatus.status !== GameStatus.STARTED && (
            <StyledContainer variant="light_blue" className={styles.gameContainer}>
              <h2>{pages.intro?.introTitle}</h2>
              <p dangerouslySetInnerHTML={{ __html: pages.intro?.introBody }}></p>
              <button className="global-button " onClick={startGame}>
                { pages.intro?.callToActionCaption }
              </button>
            </StyledContainer>
          )}


          {console.log("gameStatus.status" , gameStatus.status)}
          {console.log("gameStatus.round" , gameStatus.round)}
   
            
          {gameStatus.status === GameStatus.STARTED && (
              <QuestionBox 
                messages={pages.intro}
                showBox={showBox}               
              />
          )}
        </Container>}
        {/* <Timer>Timer: {secondsCount}</Timer> */}
        {gameStatus.status !== GameStatus.FINISHED &&
        <ScoreHolder>
          Total Score    
          <Score>{((gameStatus.score.toString().length === 1 ? '0' : '') + gameStatus.score).slice((gameStatus.score.toString().length === 1 ? -2 : 0))}</Score>
        </ScoreHolder>}
        {gameStatus.status === GameStatus.FINISHED && (
          <Modal>
            <Results
              className="mission-results"
              onComplete={() => {
                if (props.onComplete) return;
              }}
              resetSegment={() => {
                if (props.resetSegment) return;
              }}
              data={props.data}
              options={options}
              pages={pages}
              gameStatus={gameStatus}
              elements={stateElements}
              goToNext={() => onComplete()}
            />
          </Modal>          
        )}
      </InteractionContainer>
    </ModalProvider>
  );
}

const TopContainer = styled.div`
  position: absolute;
  top: 25px;
  left: 150px;
  display: flex;
`;


const Instructions = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #ABA4A7;
  line-height: 60px;  
`;

const Container = styled.div`
  //height: 480px;
  width: 400px;
  position: absolute;
  top: 80px;
  right: 60px;
`;

const Board = styled.div`
  position: absolute;
  top: 130px;
  left: 60px;
`;

const Timer = styled.div`
  right: 280px;
  bottom: 71px;
  height: 50px;
  width: 160px;
  position: absolute;
  color: white;
  text-align: center;
  display: inline-block;
  font-size: 1.3rem;
  font-weight: bold;
  font-weight: 500;
  padding: 0.5em 1.4em;
  -webkit-transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  border: 2px solid #78a1bb;
  -webkit-clip-path: polygon(
    0% 20px,
    20px 0%,
    100% 0%,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0% 100%
  );
  -webkit-clip-path: polygon(
    0% 20px,
    20px 0%,
    100% 0%,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0% 100%
  );
  -webkit-clip-path: polygon(
    0% 20px,
    20px 0%,
    100% 0%,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0% 100%
  );
  -webkit-clip-path: polygon(
    0% 20px,
    20px 0%,
    100% 0%,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0% 100%
  );
  clip-path: polygon(
    0% 20px,
    20px 0%,
    100% 0%,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0% 100%
  );
`;

const ScoreHolder = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 450px;
  bottom: 128px;
  color: #78A1BB;
  text-align: center;
  font-size: 20px;
  font-family: 'Rajdhani';
  font-weight: bold;
  padding: 0.5em 1.4em;
  -webkit-transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
`;

const Score = styled.div`
  width: 72px;
  color: white;
  text-align: center;
  display: inline-block;
  font-size: 36px;
  font-family: 'Rajdhani';
  font-weight: bold;
  margin-top: 5px;
  padding: 3px;
  border: 1px solid #78a1bb;
`;

// Separed the states on multiples Wrappers
// IMPORTANT! Most of the logic is on the MissionElementsProvider
const providers = (Component) => {
  return (props) => {
    return (
      <GameStatusProvider>
        <TimerProvider>
          <ProgressProvider>
            <MissionElementsProvider
              elements={props.data.elements}
              options={props.data.options}
            >
              <QuestionProvider>
                <Component {...props} />
              </QuestionProvider>
            </MissionElementsProvider>
          </ProgressProvider>
        </TimerProvider>
      </GameStatusProvider>
    );
  };
};

export default providers(MissionElements);
